import { RootAppState } from 'store/configureStore'
import { bomItemSelector } from './bomItemSelector'

export const bomItemIssuesSelector =
  (bomItemId: string) => (state: RootAppState) => {
    const bomItem = bomItemSelector(state, bomItemId)

    switch (bomItem?.type) {
      case 'Row':
        return bomItem.issues
      default:
        return null
    }
  }

export const bomItemIssuesCounterSelector =
  (bomItemId: string) => (state: RootAppState) => {
    return bomItemIssuesSelector(bomItemId)(state)?.length
  }
